import React, { ComponentType } from 'react';
import StoreSettings from './StoreSettings';

const Router: ComponentType = () => {
  return <StoreSettings />;
};

export default Router;
